import { useState, useEffect } from "react";
import { NextPage, GetServerSideProps } from "next";
import { NextRouter, useRouter } from "next/router";
import Head from "next/head";
import _ from "lodash";
// Components
import { Layout } from "../../components/templates";
import { FilterSort, ProductLists } from "../../components/organisms";
// Configs
import { routesName } from "../../configs";
import { Locations } from "../../configs/datatype";
// Utils
import { setRoute } from "../../utils";

interface ProductsProps {
  query: any;
}

const Products: NextPage<ProductsProps> = (props: ProductsProps) => {
  const { query } = props;

  const { category } = query;

  const [location, setLocation] = useState<Partial<Locations>>({});
  const [categored, setCategored] = useState<number>(Number(category) || 0);
  const [sorted, setSorted] = useState<string>("");

  const router: NextRouter = useRouter();

  const handleSetLocation = (value: Locations) => {
    setLocation(value);
  };

  const handleSetCategory = (value: number) => {
    setCategored(categored === value ? 0 : value);

    if (categored === value) {
      router.replace(setRoute(routesName.PRODUCTS));

      return;
    }

    router.replace({
      pathname: setRoute(routesName.PRODUCTS),
      query: {
        category: value,
      },
    });
  };

  const handleSetSort = (value: string) => {
    setSorted(sorted === value ? "" : value);
  };

  return (
    <Layout doSetLocation={handleSetLocation}>
      {/* SEO */}
      <Head>
        <title>Foodizmart - Find Food, Serve Guest</title>
        <meta
          name="description"
          content="Temukan hidangan tepat untuk acaramu."
        />
      </Head>

      {/* Content */}
      <section className="py-4 osahan-main-body">
        <div className="osahan-listing">
          <FilterSort
            sorted={sorted}
            categored={categored}
            doSetCategory={handleSetCategory}
            doSetSort={handleSetSort}
          />

          <ProductLists
            location={location}
            sorted={sorted}
            categored={categored}
          />
        </div>
      </section>
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req, query } = context;

  return { props: { query } };
};

export default Products;
